import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const items = [
  { q: "Do I need programming experience?", a: "No. The bootcamp is beginner-friendly and designed so participants can follow even without traditional programming experience." },
  { q: "Do I need a laptop?", a: "Yes. Bring your own laptop and charger because this is a hands-on bootcamp." },
  { q: "What are we building?", a: "We'll demonstrate how an idea can move through a structured process toward a functional web application." },
  { q: "What is vibe coding?", a: "Vibe coding is an AI-assisted approach where natural-language instructions help create, modify, test, and improve software." },
  { q: "Will I become a software developer in four hours?", a: "No. The goal is to give you a practical framework and hands-on experience that you can continue developing after the bootcamp." },
  { q: "Will I receive a certificate?", a: "Yes. Participants who complete the bootcamp will receive a Moolah Tech Certificate of Completion." },
  { q: "Where is the bootcamp?", a: "3rd Floor Function Hall, Tanza Municipal Building, Tanza, Cavite." },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 sm:py-28">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="eyebrow mb-3">Questions before you build</div>
        <h2 className="text-3xl sm:text-5xl font-bold text-white mb-10">Frequently asked.</h2>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it,i) => (
            <AccordionItem key={i} value={`i${i}`} className="glass px-5 border-none">
              <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left text-white hover:no-underline">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
